import './index.css'
import Button from '../button'

function ValueStrip(){
    return (
        <section className="value-strip">
          <div className="value-pill">
            <span className="value-label">Reads</span>
            <span className="value-text small-text">Continuously monitors the sites and sources you care about</span>
          </div>
          <div className="value-pill">
            <span className="value-label">Understands</span>
            <span className="value-text small-text">Surfaces themes, trends and what’s worth responding to</span>
          </div>
          <div className="value-pill">
            <span className="value-label">Voice</span>
            <span className="value-text small-text">Drafts in your tone - informed, not generic</span>
          </div>
          <div className="value-pill">
            <span className="value-label">Ships</span>
            <span className="value-text small-text">Schedule and publish across your personal and brand pages</span>
          </div>
        </section>
)
}

export default ValueStrip